export default function Error404() {
  return <div>Oops! Algo deu errado</div>;
}
